import utils from '../utils'
import api from '../apis'

export default {
    state: {
        scheduleList: [],
        itineraryNote: ''
    },
    getters: {
        getPreviewStore() {
            return JSON.parse(localStorage.getItem('Preview'));
        }
    },
    mutations: {
        setPreview(state, Preview) {
            state = localStorage.setItem('Preview', JSON.stringify(Preview));
        },
        removePreview() {
            localStorage.removeItem('Preview');
        }
    },
    actions: {
        insertPreview({ commit }, Preview) {
            commit('setPreview', Preview)
        },
        deletePreview({ commit }) {
            commit('removePreview')
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/previewStore.js